import React from "react";

export default ({ data }) => {
  return (
    <div className="grid grid-cols-1 gap-0 lg:gap-6 lg:grid-cols-3">
      <div>
        <h5 className="border-b border-gray-200 text-base font-bold pb-3 mb-3">
          DIGITAL PLANT MANAGEMENT
        </h5>

        {data.navsolcol1.map((item) => (
          <a key={item.url} href={item.url}>
            <div>
              <h5 className="text-base font-bold mb-1">{item.displaytext}</h5>
              <p className="text-sm mb-6">{item.description}</p>
            </div>
          </a>
        ))}
      </div>

      <div>
        <h5 className="border-b border-gray-200 text-base font-bold pb-3 mb-3">
          BY ROLE
        </h5>

        {data.navsolcol2.map((item) => (
          <a key={item.url} href={item.url}>
            <div>
              <h5 className="text-base font-bold">{item.displaytext}</h5>
              <p className="text-sm mb-6">{item.description}</p>
            </div>
          </a>
        ))}
      </div>

      <div>
        <h5 className="border-b border-gray-200 text-base font-bold pb-3 mb-3">
          BY INDUSTRY
        </h5>

        {data.navsolcol3.map((item) => (
          <a key={item.url} href={item.url}>
            <div>
              <h5 className="text-base font-bold">{item.displaytext}</h5>
              <p className="text-sm mb-6">{item.description}</p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};
